export default __webpack_public_path__ + "static/media/trang.c1ebeba1.jpg";